/**
 * Normalize an Accepted-like response from the adapter into a boolean.
 * Adapter implementations may return an object like { Ok: true } or { ok: true }
 * or embed the object under `data` — this helper normalizes those shapes.
 * @param res - raw adapter response
 * @returns boolean - true when the operation was accepted/succeeded
 */
export function extractAccepted(res: unknown): boolean {
  if (!res) return false;
  // try to access common shapes safely
  const r = res as Record<string, unknown>;
  const accepted = (r?.data as unknown) ?? (r?.Accepted as unknown) ?? res;
  if (!accepted) return false;
  const acc = accepted as Record<string, unknown>;
  return Boolean(acc['Ok'] ?? acc['ok'] ?? acc['Accepted'] ?? true);
}
